import React, { useContext } from 'react';
import { FaEnvelope, FaHandPaper, FaPhoneAlt } from 'react-icons/fa';
import { IAuctionItem } from 'src/pages/CatalogPage/CatalogPage.i';
import { LoginContext } from 'src/lib/LoginContext';
import { BidModal } from 'src/components/PlaceBid/PlaceBidModal';
import { PlaceBidButton } from 'src/components/PlaceBid/PlaceBid.style';
import { TAuctionTypeID } from 'src/pages/CatalogPage/Catalog.i';

import { useOverlayTriggerState } from '@react-stately/overlays';
import { SolidButton } from '@riac/design-system';
import { BiddingContext, NotEnabledMessage } from 'src/lib/BiddingContext';

export type TBidButtonPage = 'catalog' | 'detail' | 'cart' | 'my-bids';
interface IPlaceBid {
  type: 'sealed' | 'phone' | 'increment';
  page: TBidButtonPage;
  item: IAuctionItem;
  auctionTypeID: TAuctionTypeID;
  addBid(bid?: number, bidPlus?: number): void;
}

export const PlaceBid = (props: IPlaceBid):JSX.Element => {
  const bidModalOverlayState = useOverlayTriggerState({});
  const { isLoggedIn } = useContext(LoginContext);
  const { placeTimedAuctionBid, checkEnabled, setMessageForLot } = useContext(BiddingContext);
  const { auctionTypeID, page } = props;

  async function toggleSealedBidModal():Promise<void> {
    if(!isLoggedIn) return;
    if(auctionTypeID === TIMED_AUCTION_TYPE_ID && !await checkEnabled()) {
      setMessageForLot(props.item.LotNumber, 'error', NotEnabledMessage);
      return;
    }
    bidModalOverlayState.open();
  }
  async function bidNext():Promise<void> {
    if(!isLoggedIn || auctionTypeID !== TIMED_AUCTION_TYPE_ID) return;
    const placed = await placeTimedAuctionBid(props.item);
    if(!placed.success) {
      return;
    }
    if(typeof props.addBid === 'function') {
      props.addBid();
    }
  }
  // No bid text on catalog page
  let bidText = auctionTypeID === TIMED_AUCTION_TYPE_ID
    ? (props.type === 'increment' ? 'Next' : 'Max')
    : props.type;

  if(page === 'cart' && auctionTypeID !== TIMED_AUCTION_TYPE_ID ) {
    bidText = 'Change';
  }
  if(page === 'my-bids' && auctionTypeID !== TIMED_AUCTION_TYPE_ID) {
    bidText = 'Increase';
  }

  const onPress = async () => {
    if(props.item.MyItem) {
      setMessageForLot(props.item.LotNumber, 'error', 'As the Consignor you cannot bid on your own lot.');
      return;
    }

    if(props.type === 'increment') {
      await bidNext();
    } else {
      await toggleSealedBidModal();
    }
  };

  return (
    <PlaceBidButton page={props.page} style={{flex: 1}}>
      <SolidButton excludeFromTabOrder={!isLoggedIn} onPress={onPress}>
        {props.type === 'sealed' ? <FaEnvelope /> : null}
        {props.type === 'increment' ? <FaHandPaper /> : null}
        {props.type === 'phone' ? <FaPhoneAlt /> : null}
        <span>{bidText === 'sealed' ? 'Absentee' : bidText} Bid</span>
      </SolidButton>
      {bidModalOverlayState.isOpen && (
        <BidModal
          item={props.item}
          auctionTypeId={props.auctionTypeID}
          type={props.type}
          closeModal={() => bidModalOverlayState.close()}
          bidUpdatedCallback={props.addBid}
          page={page}
        />
      )}
    </PlaceBidButton>
  );};
